import "./App.css";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import AuthProvider from "./context/AuthProvider";
import Referral from "./components/referral";
import Connect from "./components/error-page/not-connected";
function App() {
  const conect = window.navigator.onLine;
  return (
    <BrowserRouter>
      <AuthProvider>
        <Switch>
          <Route component={conect?Referral:Connect} path="/gsale" />
          <Route component={conect?Referral:Connect} path="/bhx" />
        </Switch>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
